import { NavLink, useNavigate } from "react-router-dom";
import { Home, Library, HeartPulse, BookOpen, User } from "lucide-react";

const tabs = [
  { to: "/home", icon: Home, label: "Home", id: "home" },
  { to: "/library", icon: Library, label: "Library", id: "library" },
  { to: "/checkin", icon: HeartPulse, label: "Check-In", id: "checkin" },
  { to: "/journal", icon: BookOpen, label: "Journal", id: "journal" },
  { to: "/profile", icon: User, label: "Profile", id: "profile" },
];

export const TabBar = () => {
  const navigate = useNavigate();
  return (
    <nav className="sticky bottom-0 z-30 bg-white/95 backdrop-blur-md border-t border-slate-200"
         data-testid="tab-bar">
      <div className="flex items-stretch justify-around px-1.5 pt-1.5 pb-[max(0.5rem,env(safe-area-inset-bottom))]">
        {tabs.map((t) => (
          <NavLink key={t.id} to={t.to} data-testid={`tab-${t.id}`}
            onClick={() => navigate(t.to)}
            className="flex-1 flex flex-col items-center gap-1 py-1.5 rounded-xl transition-colors">
            {({ isActive }) => (
              <>
                <t.icon size={22} strokeWidth={isActive ? 2.6 : 2}
                        className={isActive ? "text-royal" : "text-slate-400"} />
                <span className={`text-[10px] font-semibold ${isActive ? "text-royal" : "text-slate-400"}`}>
                  {t.label}
                </span>
              </>
            )}
          </NavLink>
        ))}
      </div>
    </nav>
  );
};

export default TabBar;
